var _excluded = ["url"];

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useRef } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import MenuTop from './MenuTop';
import MenuContent from './MenuContent';
import MobileMenu from './MobileMenu/MobileMenu';
import FocusTrap, { focusableElementsSelector } from '../../atoms/FocusTrap/FocusTrap';
/**
 * Status: *In progress*.
 * Category: PageElements
 **/

var Menu = function Menu(_ref) {
  var menuLinks = _ref.menuLinks,
      className = _ref.className,
      logoImageDesktopPath = _ref.logoImageDesktopPath,
      logoImageInverseDesktopPath = _ref.logoImageInverseDesktopPath,
      logoTitle = _ref.logoTitle,
      logoUrl = _ref.logoUrl,
      activeIndex = _ref.activeIndex,
      activeLinkIndex = _ref.activeLinkIndex,
      onSearchSubmit = _ref.onSearchSubmit,
      searchLabel = _ref.searchLabel,
      searchButtonLabel = _ref.searchButtonLabel,
      searchButtonAbortText = _ref.searchButtonAbortText,
      mobileMenuCloseButtonLabel = _ref.mobileMenuCloseButtonLabel,
      linkTemplate = _ref.linkTemplate,
      lockBodyOnMenuOpen = _ref.lockBodyOnMenuOpen,
      isLoggedIn = _ref.isLoggedIn,
      loginUrl = _ref.loginUrl,
      myPageUrl = _ref.myPageUrl,
      isLoading = _ref.isLoading,
      onlyLogo = _ref.onlyLogo,
      dropdownMenu = _ref.dropdownMenu,
      onCartClick = _ref.onCartClick,
      numberOfItemsInCart = _ref.numberOfItemsInCart,
      daasLink = _ref.daasLink;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      mobileMenuOpen = _useState2[0],
      setMobileMenuOpen = _useState2[1];

  var _useState3 = useState(undefined),
      _useState4 = _slicedToArray(_useState3, 2),
      lastActiveMenuContentElement = _useState4[0],
      setLastActiveMenuContentElement = _useState4[1];

  var _useState5 = useState(-1),
      _useState6 = _slicedToArray(_useState5, 2),
      openedSubmenuIndex = _useState6[0],
      setOpenedSubmenuIndex = _useState6[1];

  var mobileMenuRef = useRef();
  useEffect(function () {
    document.addEventListener('click', onClickaway);
    document.addEventListener('keydown', onGlobalKeyDown);
    return function () {
      document.removeEventListener('click', onClickaway);
      document.removeEventListener('keydown', onGlobalKeyDown);
    };
  });

  var defaultLinkTemplate = function defaultLinkTemplate(_ref2) {
    var url = _ref2.url,
        otherProps = _objectWithoutProperties(_ref2, _excluded);

    return /*#__PURE__*/React.createElement("a", _extends({
      href: url
    }, otherProps));
  };

  var LinkTemplate = linkTemplate || defaultLinkTemplate;
  var openedSubmenu = null;

  var isDescendant = function isDescendant(parent, child) {
    while (child) {
      if (child === parent) {
        return true;
      }

      child = child.parentNode;
    }

    return false;
  };

  var onGlobalKeyDown = function onGlobalKeyDown(e) {
    var key = e.which || e.keyCode;

    if (key === 27 && openedSubmenuIndex !== -1) {
      // escape key
      toggleSubmenu(openedSubmenuIndex, e);
    }
  };

  var onClickaway = function onClickaway(e) {
    if (!openedSubmenu) return;
    if (isDescendant(openedSubmenu, e.target)) return;
    setOpenedSubmenuIndex(-1);
    openedSubmenu = null;
  };

  var toggleMobileMenu = function toggleMobileMenu() {
    if (!mobileMenuOpen) {
      setFocusOnFirstFocusableElement();
      setLastActiveMenuContentElement(document.activeElement);
      if (lockBodyOnMenuOpen) document.body.classList.add('body--locked');
    } else {
      returnFocusOnDialogClose();
      if (lockBodyOnMenuOpen) document.body.classList.remove('body--locked');
    }

    setMobileMenuOpen(!mobileMenuOpen);
  };

  var setFocusOnFirstFocusableElement = function setFocusOnFirstFocusableElement() {
    if (!mobileMenuRef.current) return;
    var focusableElements = mobileMenuRef.current.querySelectorAll(focusableElementsSelector);
    if (!focusableElements.length) return;
    focusableElements[0].focus();
  };

  useEffect(setFocusOnFirstFocusableElement);

  var returnFocusOnDialogClose = function returnFocusOnDialogClose() {
    if (lastActiveMenuContentElement) lastActiveMenuContentElement.focus();
  };

  var toggleSubmenu = function toggleSubmenu(submenuIndex, e) {
    e.stopPropagation();

    if (openedSubmenuIndex === submenuIndex) {
      setOpenedSubmenuIndex(-1);
      openedSubmenu = null;
    } else {
      setOpenedSubmenuIndex(submenuIndex);
      openedSubmenu = e.target;
    }
  };

  var renderMobileMenu = function renderMobileMenu(Component) {
    var additionalProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return /*#__PURE__*/React.createElement(Component, _extends({
      ref: mobileMenuRef
    }, additionalProps), /*#__PURE__*/React.createElement(MobileMenu, {
      isOpen: mobileMenuOpen,
      LinkTemplate: LinkTemplate,
      onMobileMenuToggle: toggleMobileMenu,
      menuLinks: menuLinks,
      selectedHeaderIndex: activeIndex,
      onMenuItemSelected: toggleMobileMenu,
      isLoading: isLoading,
      mobileMenuCloseButtonLabel: mobileMenuCloseButtonLabel
    }));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classnames('menu', _defineProperty({}, className, className))
  }, !onlyLogo && menuLinks && menuLinks.length > 1 && /*#__PURE__*/React.createElement(MenuTop, {
    activeIndex: activeIndex,
    menuLinks: menuLinks,
    LinkTemplate: LinkTemplate
  }), /*#__PURE__*/React.createElement(MenuContent, {
    logo: {
      image: logoImageDesktopPath,
      imageInverted: logoImageInverseDesktopPath,
      title: logoTitle,
      url: logoUrl
    },
    LinkTemplate: LinkTemplate,
    menuLink: menuLinks && menuLinks[activeIndex],
    onToggleSubmenu: toggleSubmenu,
    openedSubmenuIndex: openedSubmenuIndex,
    activeIndex: activeLinkIndex,
    loginUrl: loginUrl,
    onMobileMenuToggle: toggleMobileMenu,
    onSearchSubmit: onSearchSubmit,
    searchLabel: searchLabel,
    searchButtonLabel: searchButtonLabel,
    searchButtonAbortText: searchButtonAbortText,
    isLoggedIn: isLoggedIn,
    myPageUrl: myPageUrl,
    isLoading: isLoading,
    onlyLogo: onlyLogo,
    dropdownMenu: dropdownMenu,
    onCartClick: onCartClick,
    numberOfItemsInCart: numberOfItemsInCart,
    daasLink: daasLink
  }), !onlyLogo && mobileMenuOpen && renderMobileMenu(FocusTrap, {
    as: 'div'
  }));
};

Menu.propTypes = {
  menuLinks: PropTypes.arrayOf(PropTypes.shape({
    heading: PropTypes.shape({
      text: PropTypes.string,
      url: PropTypes.string
    }),
    links: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string,
      url: PropTypes.string
    }))
  })),
  logoImageDesktopPath: PropTypes.string,
  logoImageInverseDesktopPath: PropTypes.string,
  logoTitle: PropTypes.string,
  logoUrl: PropTypes.string,
  activeIndex: PropTypes.number,
  activeLinkIndex: PropTypes.number,
  onSearchSubmit: PropTypes.func,
  searchLabel: PropTypes.string,
  searchButtonLabel: PropTypes.string,
  searchButtonAbortText: PropTypes.string,
  mobileMenuCloseButtonLabel: PropTypes.string,
  linkTemplate: PropTypes.func,
  lockBodyOnMenuOpen: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  loginUrl: PropTypes.string,
  myPageUrl: PropTypes.string,
  cartUrl: PropTypes.string,
  isLoading: PropTypes.bool,
  onlyLogo: PropTypes.bool
};
export default Menu;